export const requestKeys = {
  all: ["requests"] as const,
  lists: () => [...requestKeys.all, "list"] as const,
  byRequester: (requesterId: string) =>
    [...requestKeys.all, "byRequester", requesterId] as const,
  detail: (id: string) => [...requestKeys.all, "detail", id] as const,
} as const;
